import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavigationLinkDirective } from '../../directives/navigation-link/navigation-link.directive';
import { IconSize } from '../icon/entities/icon-sizes.entity';
import { ShIconModule } from '../icon/icon.module';
import { FontSize } from './entities/font-sizes.entity';
import { InlineDescriptionListDirection } from './entities/inline-description-list-direction.entity';
import {
    BaseInlineDescriptionListItem,
    EventListenerInlineDescriptionListItem,
    InlineDescriptionListItem,
    NavigationLinkInlineDescriptionListItem
} from './entities/inline-description-list-item.entity';

export * from './entities/inline-description-list-direction.entity';
export * from './entities/inline-description-list-item.entity';

@Component({
    standalone: true,
    selector: 'sh-inline-description-list',
    templateUrl: './inline-description-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, ShIconModule, NavigationLinkDirective]
})
export class ShInlineDescriptionListComponent {
    readonly defaultIconSize: IconSize = IconSize.REGULAR;

    @Input() items!: InlineDescriptionListItem[];
    @Input() direction: InlineDescriptionListDirection = InlineDescriptionListDirection.Horizontal;
    @Input() fontSize?: FontSize = FontSize.SMALL;
    @Input() diminish?: boolean = false;
    @Input() fullWidth?: boolean = false;

    get classNames(): string {
        let classNames: string[] = [];

        classNames = [...classNames, this.direction];

        if (this.fontSize && this.fontSize !== FontSize.SMALL) {
            classNames = [...classNames, this.getFontSizeModifier()];
        }

        return classNames.join(' ');
    }

    private getFontSizeModifier(): string {
        return `-sh-font-${this.fontSize}`;
    }

    handleClick(event: MouseEvent, item: EventListenerInlineDescriptionListItem): void {
        item.eventListener(event);
    }

    baseInlineDescriptionListItemGuard(item: InlineDescriptionListItem): item is BaseInlineDescriptionListItem {
        return 'term' in item;
    }

    eventListenerInlineDescriptionListItemGuard(
        item: InlineDescriptionListItem
    ): item is EventListenerInlineDescriptionListItem {
        return 'eventListener' in item;
    }

    navigationLinkInlineDescriptionListItemGuard(
        item: InlineDescriptionListItem
    ): item is NavigationLinkInlineDescriptionListItem {
        return 'navigationLink' in item;
    }

    inlineDescriptionListAsDetailsGuard(item: InlineDescriptionListItem): boolean {
        return Array.isArray(item.details);
    }
}
